<template>
  <v-list-item @click="logOut">
    <template #prepend>
      <v-icon icon="mdi-logout" />
    </template>
    <v-list-item-title>Uitloggen</v-list-item-title>
  </v-list-item>
</template>

<script>
import { useRouter } from "vue-router";
import { useAuthStoreRefactor } from "../../stores/authStoreRefactor";
import {
  hasActiveMsalSession,
  logoutFromMsal,
} from "../../services/msalService";

export default {
  name: "LogOutButton",
  setup() {
    const router = useRouter();
    const authStore = useAuthStoreRefactor();

    const logOut = async () => {
      try {
        console.log("LogOutButton: Starting logout process");
        console.log(
          "LogOutButton: Initial localStorage token:",
          localStorage.getItem("token"),
        );

        // Check if user has an active MSAL session BEFORE clearing local auth
        const hasMsalSession = hasActiveMsalSession();
        console.log("LogOutButton: Has MSAL session:", hasMsalSession);

        // First, logout from our application
        console.log("LogOutButton: Calling authStore.logout()");
        await authStore.logout();
        console.log("LogOutButton: Local logout completed");
        console.log(
          "LogOutButton: localStorage token after authStore logout:",
          localStorage.getItem("token"),
        );

        if (hasMsalSession) {
          console.log(
            "LogOutButton: SSO user detected, clearing app-specific MSAL session",
          );

          try {
            // Clear app-specific MSAL session (preserves O365 login)
            await logoutFromMsal();
            console.log("LogOutButton: MSAL app session cleared successfully");
          } catch (msalError) {
            console.warn(
              "LogOutButton: MSAL app session clear failed:",
              msalError,
            );
            // Continue anyway since local logout succeeded
          }
        } else {
          console.log("LogOutButton: Non-SSO user detected");
        }

        // Always redirect to login after logout
        console.log("LogOutButton: Redirecting to login page with logout flag");
        // Add a flag to indicate we just logged out to prevent auto-login
        router.push("/login?logout=true");
      } catch (error) {
        console.error("LogOutButton: Error during logout:", error);
        // Fallback: redirect to login page with logout flag
        console.log("LogOutButton: Fallback redirect to login page");
        router.push("/login?logout=true");
      }
    };

    return {
      logOut,
    };
  },
};
</script>
